import { Link } from 'react-router-dom';
import { LOGO_SRC } from './Header';

const NAV_LINKS = [
  { name: 'Startseite', href: '/' },
  { name: 'Erstberatung', href: '/erstberatung' },
  { name: 'Lösungen', href: '/loesungen' },
  { name: 'Insights', href: '/insights' },
  { name: 'Über Uns', href: '/ueber-uns' },
  { name: 'Kundenlogin', href: '/login' },
];

const LEGAL_LINKS = [
  { name: 'Impressum', href: '/impressum' },
  { name: 'Datenschutzerklärung', href: '/datenschutz' },
  { name: 'Bildquellen', href: '/bildquellen' },
];

const FooterLink = ({ to, children }) => (
  <Link to={to} className="text-[0.95rem] border-b-2 border-transparent hover:border-lilac hover:text-lilac transition-colors w-fit">
    {children}
  </Link>
);

const Footer = () => (
  <footer className="sec--ink" data-testid="main-footer">
    <div className="wrap py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
        <div className="md:col-span-6">
          <Link to="/" className="inline-block bg-off border-2 border-lilac p-3 pr-4 mb-6" aria-label="gastro-beratung.de – Startseite">
            <img src={LOGO_SRC} alt="gastro-beratung.de" width="600" height="108" className="h-8 md:h-9 w-auto" />
          </Link>
          <p className="text-[0.95rem] leading-relaxed max-w-md text-off/85">
            Deine Plattform für digitale Gastronomie-Lösungen. Wir helfen dir, die richtigen digitalen Werkzeuge zu finden und einzurichten.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="label-caps text-lilac mb-5">Navigation</h4>
          <nav className="flex flex-col gap-3" aria-label="Footer-Navigation">
            {NAV_LINKS.map((link) => <FooterLink key={link.name} to={link.href}>{link.name}</FooterLink>)}
          </nav>
        </div>

        <div className="md:col-span-3">
          <h4 className="label-caps text-lilac mb-5">Rechtliches</h4>
          <nav className="flex flex-col gap-3" aria-label="Rechtliches">
            {LEGAL_LINKS.map((link) => <FooterLink key={link.name} to={link.href}>{link.name}</FooterLink>)}
          </nav>
        </div>
      </div>

      <div className="border-t-2 border-off/20 mt-12 pt-6 flex flex-wrap items-center justify-between gap-3 text-[0.9rem] text-off/80">
        <span>© {new Date().getFullYear()} gastro-beratung.de. Alle Rechte vorbehalten.</span>
        <span className="text-lilac text-xl" aria-hidden="true">✳</span>
      </div>
    </div>
  </footer>
);

export default Footer;
